import { Component, effect, inject, Injector, Signal, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { Alert } from './models/alert.model';
import { AlertService } from './services/local/alert-service';
import { AlertPopupComponent } from './components/alert-popup/alert-popup.component';
import { AsyncPipe, DOCUMENT } from '@angular/common';
import { LoadingService } from './services/local/loading-service';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import { AppConfigService } from './services/local/app-config.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AsyncPipe, AlertPopupComponent, LoadingOverlayComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  static injector: Injector;
  static credentials: string | null = localStorage.getItem('credentials');
  static email: string | null = localStorage.getItem('email');
  static mostrarBotonCerrarSesion: boolean = true;
  static kioskoId: number | null = localStorage.getItem('kioskoId') ? Number(localStorage.getItem('kioskoId')) : null;
  protected readonly title = signal('tomaturnos-turnos');
  alert$: Observable<Alert | null>;
  loading: Signal<boolean>;

  private document = inject(DOCUMENT);
  private appConfigService = inject(AppConfigService);

  constructor(injector: Injector, alertService: AlertService, loadingService: LoadingService) {
    App.injector = injector;
    this.alert$ = alertService.alert$;
    this.loading = loadingService.loadingSgnl;

    effect(() => {
      const faviconUrl = this.appConfigService.configResource.value()?.faviconUrl;
      if (!faviconUrl) {
        return;
      }
      this.document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]')
        .forEach(link => link.href = faviconUrl);
    });
  }
}
